<template>
  <div class="modal" @mousedown.self="closePremiumModal">
    <div class="modal-dialog modal-dialog-lg">
      <div class="modal-content dark-bg">
        <div class="modal-header mb-1 flex flex-end"><span class="modal-close" @click="closePremiumModal"><i class="icon-close"></i></span></div>
        <div class="text-center">
          <img src="../assets/img/logo.svg" alt="logo">
        </div>
        <div class="row">
          <div class="col-md-6 order-2-xs">
            <div class="premium-title">
              {{$lang.messages.get_premium_modal.features.title}}
            </div>
            <div class="premium-feature flex" :key=feature.id v-for="feature in features">
              <div class="premium-feature-icon">
                <div :class="'icon-'+ feature.icon"></div>
              </div>
              <div class="premium-feature-content">
                <div class="premium-feature-title text-lg text-bold">{{feature.title}}</div>
                <div class="">
                  <span class="premium-feature-text" :key=item.index v-for="item in feature.text">{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="content-block-item -get-premium">
              <div class="modal-title text-center mb-2">{{$lang.messages.get_premium_modal.titleAndroid}}</div>
              <div class="flex flex-wrap-xs">
                <label class="radio-wrapper -premium" :class="{active: premiumPlan === 'month'}">
                  <input name="premiumPlan" type="radio" class="radio-input" value="month" v-model="premiumPlan">
                  <span>
                    <span class="radio-check"></span>
                    <span class="radio-label">{{$lang.messages.get_premium_modal.monthly}}</span>
                  </span>
                  <span>
                    <span class="text-lg text-bold">$2.99 </span><br>
                    <span class="text-sm">per month</span>
                  </span>
                </label>
                <label class="radio-wrapper -premium" :class="{active: premiumPlan === 'year'}">
                  <input name="premiumPlan" type="radio" class="radio-input" value="year" v-model="premiumPlan">
                  <span>
                    <span class="radio-check"></span>
                    <span class="radio-label">{{$lang.messages.get_premium_modal.yearly}}</span>
                  </span>
                  <span class="premium-sale">{{$lang.messages.get_premium_modal.save_20}}</span>
                  <span>
                    <span class="text-lg text-bold">$2.41</span><br>
                    <span class="text-sm">{{$lang.messages.get_premium_modal.per_month}}</span>
                  </span>
                </label>
              </div>
              <div class="flex price-arrow">
                <div class="flex">
                  <svg width="52" height="25" viewBox="0 0 52 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M51 21C35.3333 26.1667 4 29.5 4 1.5M4 1.5L0.5 5.5M4 1.5L8 5.5" stroke="#9F81F8"/>
                  </svg>
                  <div class="premium-label-free">
                    <div class="text-thin">{{$lang.messages.get_premium_modal.get}}</div>
                    {{$lang.messages.get_premium_modal.two_month_free}}
                  </div>
                </div>
              </div>
              <button v-on:click="buyPremium"
                      class="btn btn-black w-100">
                <img src="../assets/img/g-pay.png" alt="g-pay">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'GetPremiumModalAndroid',
  props: {
    customer: Object,
    type: {
      type: String,
      default: 'base'
    },
    initialPremiumPlan: String,
  },
  data: function () {
    return {
      features: [
        {
          id: 0,
          title: this.$lang.messages.get_premium_modal.features.feture_1_title,
          icon: 'settings',
          text: this.$lang.messages.get_premium_modal.features.feture_1_texts
        },
        {
          id: 1,
          title: this.$lang.messages.get_premium_modal.features.feture_2_title,
          icon: 'themes',
          text: this.$lang.messages.get_premium_modal.features.feture_2_texts
        },
        {
          id: 2,
          title: this.$lang.messages.get_premium_modal.features.feture_3_title,
          icon: 'statistic',
          text: this.$lang.messages.get_premium_modal.features.feture_3_texts
        },
        {
          id: 3,
          title: this.$lang.messages.get_premium_modal.features.feture_4_title,
          icon: 'remote',
          text: this.$lang.messages.get_premium_modal.features.feture_4_texts
        }
      ],
      premiumPlan: this.initialPremiumPlan || 'year',
    }
  },
  methods: {
    closePremiumModal () {
      this.$emit('closepremiummodal');
    },
    updateSettings(settingsInObj){
      this.$emit('updatesettings', settingsInObj)
    },
    buyPremium() {
      if (window.Android) {
        window.Android.openPurchaseDialog(this.premiumPlan)
      }
    }
  },
}

</script>
<style lang="scss" scoped>
.dark-bg {
  background-color: #F5F7FB;
}

.modal-dialog {
  top: 0;
  border-radius: 0;
}

.modal-title {
  padding: 0;
  display: block;
}

.premium-title {
  font-size: 24px;
  line-height: 120%;
  text-align: center;
}

.premium-feature-icon {
  font-size: 23px;
}

.btn-black {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px;
  background-color: #000000;
}

.content-block-item {
  margin: 0;
  &.-get-premium {
    background: none;
  }
}

.price-arrow {
  padding-top: 3px;
  padding-left: 15px;
  margin-bottom: 33px;
}

.radio-wrapper {
  &.-premium {
    justify-content: space-between;
    align-items: center;
    position: relative;
    height: 64px;

    .premium-sale {
      position: absolute;
      top: -1px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.premium-feature-text {
  font-size: 14px;
}
</style>
